<template>
  <v-card>
    <v-img>
      <div id="photo-map" class="photo-map"></div>
    </v-img>
  </v-card>
</template>

<script>
import 'leaflet';
import 'leaflet.markercluster';

export default {
  props: {
    location: Object,
  },
  data() {
    return {
      L: window.L,
      map: [],
      marker: null,
      popup: null,
    };
  },
  mounted() {
    this.map = this.L.map('photo-map').setView(
      this.location.coordinates,
      this.location.zoom,
    );
    this.L.tileLayer(
      'https://api.tiles.mapbox.com/v4/{mapId}/{z}/{x}/{y}.png?access_token={token}',
      {
        attribution:
          'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, <a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
        maxZoom: 18,
        mapId: 'mapbox.streets',
        token:
          'pk.eyJ1IjoiZGFubTEzIiwiYSI6ImNqcnI0NW5mNzExcjQzeXFlbWtieTdnZGIifQ.1x1k8ukgpHLhrUDKgiu5iw',
      },
    ).addTo(this.map);
    // this.L.marker(this.location.marker).addTo(this.map);
    this.L.circle(this.location.marker, {
      color: 'blue',
      fillColor: '#3388ff',
      fillOpacity: 0.5,
      radius: this.location.markerRadius,
    })
      .bindPopup(this.location.markerPopup)
      .addTo(this.map);
  },
};
</script>

<style scoped>
@import '../../node_modules/leaflet/dist/leaflet.css';
@import '../../node_modules/leaflet.markercluster/dist/MarkerCluster.css';
.photo-map {
  width: 100%;
  height: 400px;
  font-weight: bold;
  font-size: 13px;
}
</style>
